export var PlatformPathname;
(function (PlatformPathname) {
    PlatformPathname["BOOKING_APPOINTMENT_PATHNAME"] = "/book-appointment";
    PlatformPathname["BOOKING_APPOINTMENT_BUYERS_AGENT_PATHNAME"] = "/book-appointment/buyers-agent";
    PlatformPathname["BUYERS_AGENT_PATHNAME"] = "/buyers-agent";
    PlatformPathname["TIME_SELECTION_PROCESS_PATHNAME"] = "/book-appointment/process";
    PlatformPathname["STAMP_DUTY_PATHNAME"] = "/stamp-duty-calculator";
    PlatformPathname["PROPERTY_REPORT_PATHNAME"] = "/property-report";
    PlatformPathname["CHECK_YOUR_CREDIT_SCORE_PATHNAME"] = "/check-your-credit-score";
    PlatformPathname["FREE_CREDIT_SCORE_CHECK_PATHNAME"] = "/free-credit-score-check";
    PlatformPathname["CREDIT_SCORE_RESULT_PATHNAME"] = "/credit-score/result";
    PlatformPathname["REFINANCE_FUNNEL_PATHNAME"] = "/home-loans/basics/refinance/refinance-loan-amount";
    PlatformPathname["NEW_PURCHASE_FUNNEL_PATHNAME"] = "/home-loans/basics/new-home/purchase-price";
    PlatformPathname["BORROWING_POWER_FUNNEL_PATHNAME"] = "/home-loans/basics/borrowing-power/applicants";
    PlatformPathname["REFER_A_FRIEND_PATHNAME"] = "/home-loans/refer-a-friend";
})(PlatformPathname || (PlatformPathname = {}));
//# sourceMappingURL=PlatformPathname.js.map